'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _antd = require('@adparlor-devops/antd');

var _reactIntl = require('react-intl');

require('./RuleBranch.scss');

var _ConditionGroup = require('./ConditionGroup');

var _ConditionGroup2 = _interopRequireDefault(_ConditionGroup);

var _Task = require('./Task');

var _Task2 = _interopRequireDefault(_Task);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Panel = _antd.Collapse.Panel;

var RuleBranch = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(RuleBranch, _React$Component);

  function RuleBranch() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RuleBranch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RuleBranch.__proto__ || (0, _getPrototypeOf2.default)(RuleBranch)).call.apply(_ref, [this].concat(args))), _this), _this.removeRuleBranchOrConditionGroup = function (isFirstConditionGroup, ruleBranchId, conditionGroupId) {
      var _this$props = _this.props,
          options = _this$props.options,
          ruleBranch = _this$props.ruleBranch;
      var conditionGroups = ruleBranch.conditionGroups,
          clauseIntro = ruleBranch.clauseIntro;
      // If it is the first conidtionGroup, remove the ruleBranch

      var removeRuleBranch = isFirstConditionGroup && conditionGroups && conditionGroups.length === 1 || clauseIntro === 'ELSE';
      if (removeRuleBranch) {
        options.actions.ruleBranch.remove(ruleBranch);
      } else {
        // Else, remove the conidtionGroup instead
        var conditionGroupToRemove = conditionGroups.find(function (group) {
          return group.id === conditionGroupId;
        });
        options.actions.conditionGroup.remove(ruleBranchId, conditionGroupToRemove);
      }
    }, _this.shouldShowRemoveButton = function (id, isFirstConditionGroup) {
      var ruleBranch = _this.props.ruleBranch;

      if (ruleBranch.clauseIntro === 'IF') {
        return !isFirstConditionGroup;
      } else if (ruleBranch.clauseIntro === 'ELSE') {
        return true;
      }
      if (id) {
        return true;
      }
      return false;
    }, _this.renderGroupHeader = function (_ref2, isFirstConditionGroup, invalidGroup) {
      var id = _ref2.id,
          title = _ref2.title,
          headerLabel = _ref2.headerLabel;
      var ruleBranch = _this.props.ruleBranch;

      var invalidBadge = invalidGroup === true ? _react2.default.createElement(_antd.Badge, { count: '!' }) : null;
      var showRemoveButton = _this.shouldShowRemoveButton(id, isFirstConditionGroup);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            _antd.Col,
            { span: 20, key: 'rule-branch-title-' + ruleBranch.id, className: 'condition-title' },
            headerLabel ? _react2.default.createElement(
              'div',
              { className: 'header-label' },
              headerLabel
            ) : null,
            title,
            ' ',
            invalidBadge
          ),
          _react2.default.createElement(
            _antd.Col,
            {
              span: 4,
              className: 'text-align-right',
              key: 'rule-branch-actions-' + ruleBranch.id
            },
            showRemoveButton && _react2.default.createElement(_antd.Button, {
              shape: 'circle',
              icon: 'close',
              className: 'rule-branch-actions-remove',
              key: 'rule-branch-actions-remove-' + ruleBranch.id,
              onClick: function onClick() {
                return _this.removeRuleBranchOrConditionGroup(isFirstConditionGroup, ruleBranch.id, id);
              }
            })
          )
        )
      );
    }, _this.quantifierSelector = function (ruleBranchID, currentQuantifier, selectedQuantifier) {
      if (currentQuantifier !== selectedQuantifier) {
        _this.props.options.actions.ruleBranch.update(ruleBranchID, { quantifier: selectedQuantifier });
      }
      _this.props.options.actions.conditionGroup.add(ruleBranchID);
    }, _this.showAddConditionGroup = function () {
      var ruleBranch = _this.props.ruleBranch;

      return _react2.default.createElement(
        _antd.Dropdown,
        {
          overlay: _this.newConditionGroupMenu(ruleBranch.id, ruleBranch.quantifier, ruleBranch.conditionGroups.length > 1),
          getPopupContainer: function getPopupContainer(node) {
            return node.parentNode;
          },
          className: 'dropdown-condition',
          trigger: ['click']
        },
        _react2.default.createElement(
          _antd.Button,
          { type: 'dashed', className: 'condition-group-add-button' },
          '+ ',
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'rulebranch.collapse.conditiongroup.add.button',
            defaultMessage: 'Additional Condition Group'
          })
        )
      );
    }, _this.renderConditionGroups = function () {
      var _this$props2 = _this.props,
          ruleBranch = _this$props2.ruleBranch,
          options = _this$props2.options,
          editingConditions = _this$props2.editingConditions,
          meta = _this$props2.meta,
          invalidEntities = _this$props2.invalidEntities,
          ruleSettings = _this$props2.ruleSettings;

      if (ruleBranch.conditionGroups) {
        // ELSE clauseIntro does not have conditionGroups
        return ruleBranch.conditionGroups.map(function (conditionGroup, conditionGroupIndex) {
          var isFirstConditionGroup = conditionGroupIndex === 0;
          return _react2.default.createElement(
            Panel,
            {
              header: _this.renderGroupHeader(conditionGroup, isFirstConditionGroup, invalidEntities.conditionGroups.includes(conditionGroup.id)),
              className: conditionGroup.className,
              key: 'conditionGroup-' + conditionGroup.id
            },
            _react2.default.createElement(_ConditionGroup2.default, {
              conditionGroup: conditionGroup,
              ruleBranchID: ruleBranch.id,
              conditionGroupActions: options.actions.conditionGroup,
              conditionActions: options.actions.condition,
              metaActions: options.actions.meta,
              key: conditionGroup.id,
              editingConditions: editingConditions,
              meta: meta,
              builderActions: _this.props.builderActions,
              ruleSettings: ruleSettings
            }),
            conditionGroup.showAddConditionGroup && _this.showAddConditionGroup()
          );
        });
      }
      return null;
    }, _this.renderTasks = function () {
      var _this$props3 = _this.props,
          ruleBranch = _this$props3.ruleBranch,
          options = _this$props3.options,
          ruleSettings = _this$props3.ruleSettings,
          users = _this$props3.users,
          editingTasks = _this$props3.editingTasks;
      var taskGroup = ruleBranch.taskGroup;

      var taskDelimeter = _react2.default.createElement(
        'div',
        { className: 'task-delimeter' },
        taskGroup.quantifier === "ALL" ? "AND" : "OR"
      );
      return taskGroup.tasks.map(function (task, taskIndex) {
        return _react2.default.createElement(
          'div',
          { key: task.id },
          _react2.default.createElement(_Task2.default, {
            task: task,
            key: task.id,
            ruleBranchID: ruleBranch.id,
            ruleSettings: ruleSettings,
            removable: taskGroup.tasks.length > 1 || ruleBranch.clauseIntro === "ELSE",
            taskActions: options.actions.task,
            editing: editingTasks.includes(task.id),
            users: users,
            builderActions: _this.props.builderActions
          }),
          taskGroup.tasks[taskIndex + 1] && taskDelimeter
        );
      });
    }, _this.renderTaskGroup = function () {
      var _this$props4 = _this.props,
          ruleBranch = _this$props4.ruleBranch,
          options = _this$props4.options,
          invalidEntities = _this$props4.invalidEntities;
      var taskGroup = ruleBranch.taskGroup;

      var invalidTasks = taskGroup.tasks.filter(function (task) {
        return invalidEntities.tasks.includes(task.id);
      });

      return _react2.default.createElement(
        Panel,
        {
          header: _this.renderGroupHeader(taskGroup, true, invalidTasks.length > 0),
          className: taskGroup.className,
          key: 'taskGroup-' + ruleBranch.id
        },
        _this.renderTasks(),
        _react2.default.createElement(
          _antd.Button,
          {
            onClick: function onClick() {
              options.actions.task.add(ruleBranch.id);
            },
            type: 'dashed',
            className: 'add-task-button',
            size: 'small'
          },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'rulebranch.add.task.button',
            defaultMessage: '+ Add Task'
          })
        )
      );
    }, _this.getActiveKeys = function () {
      var ruleBranch = _this.props.ruleBranch;

      var keys = ['taskGroup-' + ruleBranch.id];
      if (ruleBranch.conditionGroups) {
        ruleBranch.conditionGroups.forEach(function (conditionGroup) {
          return keys.push('conditionGroup-' + conditionGroup.id);
        });
      }
      return keys;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RuleBranch, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.props.editingConditions !== nextProps.editingConditions || this.props.editingTasks !== nextProps.editingTasks || this.props.ruleBranch !== nextProps.ruleBranch || this.props.meta !== nextProps.meta || this.props.ruleSettings !== nextProps.ruleSettings || this.props.users !== nextProps.users || this.props.invalidEntities.conditionGroups !== nextProps.invalidEntities.conditionGroups || this.props.invalidEntities.tasks !== nextProps.invalidEntities.tasks;
    }
  }, {
    key: 'newConditionGroupMenu',
    value: function newConditionGroupMenu(ruleBranchID, currentQuantifier, limitReached) {
      var _this2 = this;

      return _react2.default.createElement(
        _antd.Menu,
        null,
        _react2.default.createElement(
          _antd.Menu.Item,
          null,
          _react2.default.createElement(
            'a',
            {
              disabled: currentQuantifier === 'ANY' && limitReached === true,
              onClick: function onClick() {
                return _this2.quantifierSelector(ruleBranchID, currentQuantifier, 'ALL');
              }
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'rulebranch.quantifier.all',
              defaultMessage: 'And'
            })
          )
        ),
        _react2.default.createElement(
          _antd.Menu.Item,
          null,
          _react2.default.createElement(
            'a',
            {
              disabled: currentQuantifier === 'ALL' && limitReached === true,
              onClick: function onClick() {
                return _this2.quantifierSelector(ruleBranchID, currentQuantifier, 'ANY');
              }
            },
            _react2.default.createElement(_reactIntl.FormattedMessage, {
              id: 'rulebranch.quantifier.any',
              defaultMessage: 'Or'
            })
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var keys = this.getActiveKeys();
      return _react2.default.createElement(
        'div',
        { className: 'ruleBranch__component' },
        _react2.default.createElement(
          _antd.Collapse,
          {
            defaultActiveKey: keys
          },
          this.renderConditionGroups(),
          this.renderTaskGroup()
        )
      );
    }
  }]);
  return RuleBranch;
}(_react2.default.Component), _class.propTypes = {
  options: _propTypes2.default.shape({
    actions: _propTypes2.default.shape({
      ruleBranch: _propTypes2.default.shape({
        remove: _propTypes2.default.func.isRequired,
        update: _propTypes2.default.func.isRequired
      }),
      task: _propTypes2.default.shape(_Task2.default.propTypes.taskActions).isRequired,
      conditionGroup: _propTypes2.default.shape(_ConditionGroup2.default.propTypes.conditionGroupActions),
      condition: _propTypes2.default.shape(_ConditionGroup2.default.propTypes.conditionActions)
    })
  }).isRequired,
  ruleBranch: _propTypes2.default.shape({
    clauseIntro: _propTypes2.default.oneOf(['IF', 'ELSEIF', 'ELSE']).isRequired,
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    priority: _propTypes2.default.number.isRequired,
    quantifier: _propTypes2.default.oneOf(['ALL', 'ANY']),
    conditionGroups: _propTypes2.default.arrayOf(_ConditionGroup2.default.propTypes.conditionGroup),
    tasks: _propTypes2.default.arrayOf(_Task2.default.propTypes.task)
  }).isRequired,
  users: _propTypes2.default.shape(_Task2.default.propTypes.users).isRequired,
  editingConditions: _ConditionGroup2.default.propTypes.editingConditions,
  editingTasks: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])).isRequired,
  meta: _propTypes2.default.shape(_ConditionGroup2.default.propTypes.meta).isRequired,
  ruleSettings: _propTypes2.default.shape(_Task2.default.propTypes.ruleSettings).isRequired,
  invalidEntities: _propTypes2.default.shape({
    ruleBranches: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
    conditionGroups: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
    conditions: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])),
    tasks: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))
  }).isRequired,
  builderActions: _propTypes2.default.func.isRequired
}, _class.defaultProps = {
  editingConditions: [],
  editingTasks: []
}, _temp2);
exports.default = RuleBranch;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Builder/components/RuleBranch.js
// module id = 3781
// module chunks = 4